<div id="confirm-frame">
    <h1 *ngIf="data.label" mat-dialog-title>{{ data.label }}</h1>

    <div mat-dialog-content>
        {{ data.message }}
    </div>

    <div mat-dialog-actions class="controls">
        <div>
            <button class="btn btn-sm btn-secondary" (click)="confirmed(false)">
                No
            </button>
        </div>
        <div>
            <button class="btn btn-sm btn-danger" (click)="confirmed(true)">
                <span>Yes</span>
            </button>
        </div>
    </div>
</div>
